import { Box, Card, Chip, Grid } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import EditIcon from "@mui/icons-material/Edit";
import Flex from "../../../../Flex";
import Text from "../../../../Text";

const ChipComponent = ({ label }: { label: string }) => (
  <Chip
    size="small"
    label={<Text>{label}</Text>}
    sx={{
      bgcolor: "#F3E5F5",
      color: "#4A148C",
      borderRadius: "20px",
      height: "28px",
    }}
  />
);

const formatCategories = [
  {
    title: "DOCUMENTS",
    icon: <DescriptionIcon sx={{ color: "#4CAF50" }} />,
    formats: [".pdf", ".doc", ".docx", ".ppt", ".pptx", ".txt"],
  },
  {
    title: "IMAGES",
    icon: <ImageIcon sx={{ color: "#2196F3" }} />,
    formats: [".jpg", ".jpeg", ".png", ".gif", ".psd"],
  },
  {
    title: "MEDIA & DESIGN",
    icon: <VideoLibraryIcon sx={{ color: "#9C27B0" }} />,
    formats: [".mp4", ".ai"],
  },
];

const sizeLimits = [
  { label: "Documents", limit: "Max 50MB" },
  { label: "Images", limit: "Max 20MB" },
  { label: "Videos", limit: "Max 500MB" },
  { label: "Design Files", limit: "Max 100MB" },
];

const SupportedFileFormats = () => (
  <Box sx={{ bgcolor: "white", borderRadius: "8px", p: 2 }}>
    <Text variant="h6" sx={{ color: "#424242", mb: 2, fontWeight: 600 }}>
      Supported File Formats
    </Text>
    <Grid container spacing={2}>
      {formatCategories.map(({ title, icon, formats }) => (
        <Grid item xs={12} sm={6} key={title}>
          <Card
            sx={{
              borderRadius: "8px",
              p: 2,
              height: "100%",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
            }}
          >
            <Flex alignItems="center" gap={1} mb={1}>
              {icon}
              <Text sx={{ fontWeight: 600, color: "#424242" }}>{title}</Text>
            </Flex>
            <Flex flexWrap="wrap" gap={1}>
              {formats.map((format) => (
                <ChipComponent key={format} label={format} />
              ))}
            </Flex>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box
      sx={{
        bgcolor: "#FFF9C4",
        borderLeft: "4px solid #db7a42",
        borderRadius: "4px",
        p: 1.5,
        mt: 2,
      }}
    >
      <Flex alignItems="center" gap={1} mb={1}>
        <EditIcon sx={{ color: "#E65100", fontSize: 18 }} />
        <Text sx={{ fontWeight: 600, color: "#E65100" }}>File Size Limits</Text>
      </Flex>
      <Flex flexWrap="wrap" gap={1}>
        {sizeLimits.map(({ label, limit }, idx) => (
          <Text key={label} sx={{ color: "#E65100" }}>
            {idx > 0 && " • "}
            {label}: {limit}
          </Text>
        ))}
      </Flex>
    </Box>
  </Box>
);

export default SupportedFileFormats;
